import styled from 'styled-components';

interface TextIconProps {
  disabled?: boolean;
}

export default styled.div.attrs({
  role: 'presentation'
})<TextIconProps>`
  ${({ theme, disabled }) => `
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 2px solid ${
      disabled
        ? theme.colors.navigation.text.disabled
        : theme.colors.navigation.text.dark
    };
    background-color: transparent;
    color: ${
      disabled
        ? theme.colors.navigation.text.disabled
        : theme.colors.navigation.text.dark
    };
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
  `}
`;
